import React from 'react';
import { FormattedMessage } from 'react-intl';
import { messages } from '../../../../messages';
import { FORM_REQUIREMENTS } from '../../../../utilities/constants';
import { useWalletRegistrationFormContext } from '../../contexts/wallet-registration-form-context';
import { STAMPS_CREDENTIALS_FIELDS } from './constants';

import style from './style.module.less';

export const StampsCredentialsPreview = () => {
  const { walletForm } = useWalletRegistrationFormContext();

  if (!walletForm[FORM_REQUIREMENTS.PAYMENT_METHOD]?.[FORM_REQUIREMENTS.STAMPS_CREDENTIALS]) {
    return null;
  }

  return (
    <div>
      <div className={style['preview-header']}>
        <FormattedMessage {...messages.stampsCredentialsPreviewHeader} />
      </div>
      <div className={style['preview-content']}>
        <FormattedMessage
          {...messages.stampsCredentialsPreview}
          values={{
            username:
              walletForm[FORM_REQUIREMENTS.PAYMENT_METHOD]?.[FORM_REQUIREMENTS.STAMPS_CREDENTIALS][STAMPS_CREDENTIALS_FIELDS.USERNAME],
            b: (chunks) => <b>{chunks}</b>,
          }}
        />
      </div>
    </div>
  );
};
